/**
 * Created by olga on 03.07.2026
 */

const ChooseLineComponent = function (unit, options) {
    UnitComponent.call(this, unit);
    this.seed = options.seed;
};

ChooseLineComponent.prototype = Object.create(UnitComponent.prototype);
ChooseLineComponent.prototype.constructor = ChooseLineComponent;

ChooseLineComponent.prototype.save = function (data) {
    data.seed = this.seed;
};

ChooseLineComponent.prototype.getVariants = function () {
    return this.unit.getData().choose.variants || [];
};

ChooseLineComponent.prototype.chooseVariants = function () {
    const variants = this.getVariants();

    if (variants.length <= ChooseLineComponent.CHOICES_AMOUNT) {
        return variants.slice();
    }

    if (!this.seed) {
        this.seed = Math.floor(Math.random() * 1000);
        this.unit.save();
    }

    const customers = Merge2.current.customers;
    const priority = variants.filter((variant) => customers.isUnitNeeded(variant));
    const rest = variants.filter((variant) => !priority.includes(variant));

    const random = new PseudoRandom(this.seed);

    const chosen = random.chooseN(priority, ChooseLineComponent.CHOICES_AMOUNT);
    if (chosen.length < ChooseLineComponent.CHOICES_AMOUNT) {
        chosen.push(...random.chooseN(rest, ChooseLineComponent.CHOICES_AMOUNT - chosen.length));
    }

    return chosen;
};

ChooseLineComponent.prototype.handleClick = function () {
    const selection = Merge2.current.field.lastSelection;
    if (!selection || this.unit.x !== selection.x || this.unit.y !== selection.y) {
        return false;
    }

    this.unit.squeeze();
    this.openWindow();

    return true;
};

ChooseLineComponent.prototype.openWindow = function () {
    cleverapps.focusManager.display({
        focus: "ChooseLineWindow",
        action: (f) => {
            new ChooseLineWindow(this);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

ChooseLineComponent.prototype.choose = function (variant) {
    const remains = Merge2.current.spawn([{ code: variant.code, stage: variant.stage }], this.unit);
    if (remains.length > 0) {
        return;
    }

    this.remove();
};

ChooseLineComponent.prototype.remove = function () {
    this.unit.onDestruction();
    this.unit.remove(true);
};

ChooseLineComponent.CHOICES_AMOUNT = 3;